import { memo } from 'react';

import DoubleCheckmarkIconSVG from '@/assets/double-checkmark-icon.svg?react';
import { merge } from '@/components';
import { Icon, IconProps } from '@/components/core';

const IDoubleCheckmarkIcon = ({ className, ...rest }: Omit<IconProps, 'SVGComponent'>) => {
  return <Icon className={merge('stroke-1.25', className)} SVGComponent={DoubleCheckmarkIconSVG} {...rest} />;
};

export const DoubleCheckmarkIcon = memo(IDoubleCheckmarkIcon) as typeof IDoubleCheckmarkIcon;
